import { Facebook, Globe, Instagram, Linkedin, MessageCircle, Send, Youtube } from 'lucide-react';
import type { SocialNetwork } from '@meshsmith/shared';

/** lucide has no "X" logo, so it is drawn here. */
function XLogo({ size = 18, className }: { size?: number; className?: string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden
      className={className}
    >
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
    </svg>
  );
}

export function SocialIcon({
  network,
  size = 18,
  className,
}: {
  network: SocialNetwork;
  size?: number;
  className?: string;
}) {
  switch (network) {
    case 'facebook':
      return <Facebook size={size} className={className} aria-hidden />;
    case 'instagram':
      return <Instagram size={size} className={className} aria-hidden />;
    case 'x':
      return <XLogo size={size} className={className} />;
    case 'youtube':
      return <Youtube size={size} className={className} aria-hidden />;
    case 'linkedin':
      return <Linkedin size={size} className={className} aria-hidden />;
    case 'whatsapp':
      return <MessageCircle size={size} className={className} aria-hidden />;
    case 'telegram':
      return <Send size={size} className={className} aria-hidden />;
    default:
      return <Globe size={size} className={className} aria-hidden />;
  }
}
